export enum ImpersonationValidationStages {
  validatingToken,
  authenticating,
  tokenError,
}
